export default __webpack_public_path__ + "static/media/profil.294cd0cc.webp";